import { Link } from "react-router-dom";
import { Sun } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-white/10 pt-24 pb-12 overflow-hidden" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="flex flex-col sm:flex-row justify-between gap-10 mb-20">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-amber-400 flex items-center justify-center">
            <Sun className="w-4 h-4 text-stone-950" />
          </span>
          <span className="font-serif text-xl text-stone-50">LumaDeck</span>
        </div>
        <p className="text-stone-500 text-sm max-w-xs leading-relaxed">
          Light your space. Power it with the sun. Solar deck lights for balconies, decks, and gardens across India.
        </p>
      </div>

      <div
        className="font-serif text-[18vw] leading-none tracking-tight text-transparent select-none text-center"
        style={{ WebkitTextStroke: "1px rgba(251,191,36,0.18)" }}
        data-testid="footer-giant-text"
      >
        LUMADECK
      </div>

      <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-stone-500 uppercase tracking-[0.2em]">
        <span>© 2026 LumaDeck</span>
        <span>1-year warranty · IP65 · Warm white 2700K</span>
        <Link to="/admin" className="hover:text-amber-400 transition-colors duration-300" data-testid="footer-admin-link">
          Orders
        </Link>
      </div>
    </div>
  </footer>
);
